class TeaWeb {
  get _instance() {
    return window.collectEvent;
  }
  _fnName(name) {
    return this._instancePrefix ? `${this._instancePrefix}.${name}` : name;
  }
  init(initOpts) {
    this._instance(this._fnName("init"), initOpts);
  }
  start() {
    this._instance(this._fnName("start"));
  }
  collectEvent({ eventName, params }) {
    this._instance(this._fnName(eventName), params);
  }
  setGlobalEventParams(eventParams) {
    if (!eventParams)
      return;
    this.config({
      evtParams: eventParams
    });
  }
  config(config) {
    this._instance(this._fnName("config"), config);
  }
  call(fnName, ...args) {
    return this._instance(this._fnName(fnName), ...args);
  }
  create(prefix) {
    return new TeaWeb(prefix);
  }
  constructor(prefix) {
    this._instancePrefix = prefix ?? "";
  }
}
export {
  TeaWeb
};

//# sourceMappingURL=web-sdk.js.map